import workflowRepository from '@/repositories/workflow.repository';
import { useMutation, useQuery } from '@tanstack/react-query';

export function useListWorkflowsQuery() {
	return useQuery({
		queryKey: ['workflows', 'list'],
		queryFn: workflowRepository.list,
	});
}

export function useGetWorkflowQuery(args: { id: string }) {
	return useQuery({
		queryKey: ['workflows', 'list', args.id],
		queryFn: () => workflowRepository.get(args),
	});
}

export function useRemoveWorkflowMutation() {
	return useMutation({
		mutationFn: workflowRepository.remove,
	});
}

export function useCreateOrUpdateWorkflowMutation() {
	return useMutation({
		mutationFn: workflowRepository.createOrUpdate,
	});
}
